<template>
  <v-layout class="scrollable mx-0">
    <v-container>
      <v-layout row class="mx-0">
        <v-flex xs12 sm12 md12>
          <br />
          <div class="text-center">
            <v-layout row>
              <v-flex xs12 md3 lg3 xl3><hr class="hr" /></v-flex>
              <v-flex xs12 md6 lg6 xl6
                ><p
                  class="display-3 text-xs-center text-sm-center text-md-center"
                >
                  DataDash Solution
                </p></v-flex
              >
              <v-flex xs12 md3 lg3 xl3><hr class="hr" /></v-flex>
            </v-layout>
            <br />
            <br />
            <p
              class="text-size text-xs-center text-sm-center text-md-center subheading"
            >
              DataDash solution is a powerful tool that can solve all your data
              collection needs in one go. It puts you in the driver’s seat for
              data-based decision-making. DataDash Solution is a dashboard that
              anyone can use to easily set up micro tasks like surveys, audio
              recordings, video recording, mystery shopping, copy editing, and
              more, for your data needs. You can choose to assign your tasks to
              the Dashers, users who are already active on the platform or
              choose to deploy the task only to your own team members through
              the DataDash app.
            </p>
          </div>
          <div class="text-center">
            <v-layout wrap>
              <v-flex
                xs12
                md3
                @mouseover="upHere = true"
                @mouseleave="upHere = false"
              >
                <v-card
                  min-height="600px"
                  v-if="!upHere"
                  class="mx-2 rounded-card bg-white hovering"
                >
                  <v-card-text class="gray--text font-weight-medium">
                    <img
                      :src="
                        require('@/assets/Flip Card 1.svg')
                      "
                      aspect-ratio="1"
                      class="mx-3 img-circle img-center outer-img"
                      justify-center
                      alt="" 
                    />
                  </v-card-text>
                  <v-card-title class="gray--text font-weight-medium">
                    <span class="headline mx-auto">Competitive Edge</span>
                  </v-card-title>
                </v-card>
                <v-card
                  min-height="600px"
                  v-else
                  class="mx-2 rounded-card background"
                  transition="fab-transition"
                >
                  <v-card-title class="white--text font-weight-medium">
                    <span class="title">Competitive Edge</span>
                  </v-card-title>
                  <v-card-text class="white--text font-weight-medium">
                    <p class="text-size2">
                      Gain a competitive edge with our advanced data collection
                      capabilities. Our platform supports the collection of both
                      structured and unstructured data, enabling you to capture
                      valuable information from various formats, such as text,
                      images, and videos. Whether it’s customer feedback,
                      product reviews, employee satisfaction survey, or census
                      data, our platform has you covered.
                    </p>
                    <img
                      :src="
                        require('@/assets/Flip Card 1.svg')
                      "
                      class="mx-3 img-rounded img-circle justify-center inner-img"
                      
                      alt=""
                    />
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex
                xs12
                md3
                @mouseover="upHere1 = true"
                @mouseleave="upHere1 = false"
              >
                <v-card
                  min-height="600px"
                  v-if="!upHere1"
                  class="mx-2 rounded-card bg-white hovering"
                >
                  <v-card-text class="gray--text font-weight-medium">
                    <img
                      :src="require('@/assets/Flip Card 2.svg')"
                      class="mx-3 img-circle img-center outer-img"
                      aspect-ratio="1"
                      justify-center
                      alt=""
                    />
                  </v-card-text>
                  <v-card-title class="gray--text font-weight-medium">
                    <span class="headline mx-auto">Data Security</span>
                  </v-card-title>
                </v-card>
                <v-card
                  min-height="600px"
                  v-else
                  class="mx-2 rounded-card background"
                >
                  <v-card-title class="white--text font-weight-medium">
                    <span class="title">Data Security</span>
                  </v-card-title>
                  <v-card-text class="white--text font-weight-medium">
                    <p class="text-size2">
                      Data security is of paramount importance to us. Rest
                      assured that our platform adheres to the highest industry
                      standards to protect your sensitive information. We employ
                      state-of-the-art encryption protocols, secure data
                      transmission, and robust access controls to safeguard your
                      data at all times. Focus on leveraging your data’s
                      potential while we take care of the security aspects.
                    </p>
                    <img
                      :src="require('@/assets/Flip Card 2.svg')"
                      class="mx-3 img-circle justify-center inner-img"
                      alt=""
                    />
                  </v-card-text> </v-card
              ></v-flex>
              <v-flex
                xs12
                md3
                @mouseover="upHere2 = true"
                @mouseleave="upHere2 = false"
              >
                <v-card
                  min-height="600px"
                  v-if="!upHere2"
                  class="mx-2 rounded-card bg-white hovering"
                >
                  <v-card-text class="gray--text font-weight-medium">
                    <img
                      :src="
                        require('@/assets/Flip Card 3.svg')
                      "
                      class="mx-3 img-circle img-center outer-img"
                      justify-center
                      alt=""
                    />
                  </v-card-text>
                  <v-card-title class="gray--text font-weight-medium">
                    <span class="headline text-xs-center text-md-center mx-auto"
                      >Efficiency and Scalability</span
                    >
                  </v-card-title>
                </v-card>
                <v-card
                  min-height="600px"
                  class="mx-2 rounded-card background"
                  v-else
                >
                  <v-card-title class="white--text font-weight-medium">
                    <span class="title">Efficiency and Scalability</span>
                  </v-card-title>
                  <v-card-text class="white--text font-weight-medium">
                    <p class="text-size2">
                      Efficiency and scalability are at the core of our
                      platform. Our streamlined data collection processes,
                      coupled with automated workflows, ensure faster turnaround
                      times and increased productivity. As your data needs grow,
                      our platform scales seamlessly, accommodating your
                      expanding requirements without compromising performance.
                    </p>
                    <img
                      :src="
                        require('@/assets/Flip Card 3.svg')
                      "
                      class="mx-3 img-circle justify-center inner-img"
                      alt=""
                    />
                  </v-card-text> </v-card
              ></v-flex>
              <v-flex
                xs12
                md3
                @mouseover="upHere3 = true"
                @mouseleave="upHere3 = false"
              >
                <v-card
                  min-height="600px"
                  v-if="!upHere3"
                  class="mx-2 rounded-card bg-white hovering"
                >
                  <v-card-text class="gray--text font-weight-medium">
                    <img
                      :src="require('@/assets/Flip Card 4.svg')"
                      class="mx-3 img-circle img-center outer-img"
                      
                      justify-center
                      alt=""
                    />
                  </v-card-text>
                  <v-card-title class="gray--text font-weight-medium">
                    <span class="headline text-xs-center text-md-center mx-auto"
                      >Analytics and Visualization</span
                    >
                  </v-card-title>
                </v-card>
                <v-card
                  min-height="600px"
                  class="mx-2 rounded-card background"
                  v-else
                >
                  <v-card-title class="white--text font-weight-medium">
                    <span class="title">Analytics and Visualization</span>
                  </v-card-title>
                  <v-card-text class="white--text font-weight-medium">
                    <p class="text-size2">
                      Make the most of your data with our powerful analytics and
                      visualization tools. Our platform provides intuitive
                      dashboards and customizable reports, allowing you to
                      uncover key trends, patterns, and insights. Empower your
                      team to make data-driven decisions, identify growth
                      opportunities, and optimize your strategies for success.
                    </p>
                    <img
                      :src="require('@/assets/Flip Card 4.svg')"
                      class="mx-3 img-circle justify-center inner-img"
                      alt=""
                    />
                  </v-card-text> </v-card
              ></v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap class="mt-5" style="background-color: white">
        <v-flex xs12 sm12 md6 lg6 class="pa-2">
          <v-img
            :src="require('@/assets/Surveys _Offered Features.svg')"
            height="400px" width="420"
          ></v-img>
        </v-flex>
        <v-flex
          xs12
          sm12
          md6
          lg6
          class="pl-3 d-flex justify-center align-center"
        >
          <div class="text-size">
            <p class="display-1 text-xs-left text-sm-left text-md-left">
              DataDash Solution helps you with:
            </p>
            <li>Baseline, Midline & End line Surveys</li>
            <li>Impact Assessment</li>
            <li>Tracking, Monitoring & Evaluation</li>
            <li>Customer feedback</li>
            <li>Market research</li>
            <li>Academic survey research</li>
            <li>Household surveys and more…</li>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 sm12 md12>
          <!-- <div class="text-md-center">
                <b class="display-1 red--text">DataDash Solution</b>
              </div> -->
          <br />
          <div class="text-center">
            <v-layout row>
              <v-flex xs12 sm12 md4 lg4 xl4><hr class="hr" /></v-flex>
              <v-flex xs12 sm12 md4 lg4 xl4
                ><p
                  class="display-3 text-xs-center text-sm-center text-md-center"
                >
                  How it Works
                </p></v-flex
              >
              <v-flex xs12 sm12 md4 lg4 xl4><hr class="hr" /></v-flex>
            </v-layout>

            <br />
            <br />
            <p
              class="text-size text-xs-center text-sm-center text-md-center subheading"
            >
              DataDash solution is a powerful tool that can solve all your data
              collection needs in one go. It puts you in the driver’s seat for
              data-based decision-making. DataDash Solution is a dashboard that
              anyone can use to easily set up micro tasks like surveys, audio
              recordings, video recording, mystery shopping, copy editing, and
              more, for your data needs. You can choose to assign your tasks to
              the Dashers, users who are already active on the platform or
              choose to deploy the task only to your own team members through
              the DataDash app.
            </p>
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap class="mt-5">
        <v-flex xs12 sm6 md6 lg6 class="pa-2">
          <v-img
            :src="require('@/assets/Self-Serve.svg')"
            height="400px" width="auto"
          ></v-img>
        </v-flex>
        <v-flex
          xs12
          sm12
          md6
          lg6
          class="pa-2 d-flex justify-center align-center"
        >
          <div class="text-size">
            <b>Self-Serve:</b>
            <br />
            <br />
            You can sign up and create your own projects. In a few easy steps.
            Our Dashboard is user-friendly and intuitive. You will be able to
            create micro-tasks on your own and budget for the tasks, deploy
            through the app and pay for the project, all on one platform.
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap class="mt-3">
        <v-flex xs12 sm12 md6 class="pa-2 d-flex justify-center align-center">
          <div class="text-size">
            <b>Managed Service:</b>
            <br />
            <br />
            If you do not wish to actively set up and drive your projects, no
            worries, we are here to help. Sign up and choose the option where
            you assign us to create and manage your projects for you.
          </div>
        </v-flex>
        <v-flex xs12 sm12 md6 class="pa-2">
          <v-img
            :src="require('@/assets/Managed_Service.svg')"
            height="400px" width="auto"
          ></v-img>
        </v-flex>
      </v-layout>
      <v-layout wrap class="mt-3">
        <v-flex xs12 sm12 md6 class="pa-2">
          <v-img :src="require('@/assets/agent-module.svg')" height="400px" width="auto"></v-img>
        </v-flex>
        <v-flex xs12 sm12 md6 class="pa-2 d-flex justify-center align-center">
          <div class="text-size">
            <b>Assign Agents:</b>
            <br />
            <br />
            We have an agent module to make your life easy! Agents are
            enumerators who you can assign several tasks to. You can bring your
            own enumerators to the platform or use the ones existing on the
            platform.
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap class="mt-3">
        <v-flex xs12 sm12 md12 class="pa-2">
          <div class="text-md-center">
            <v-layout row>
              <v-flex xs12 sm12 md4 lg4 xl4><hr class="hr" /></v-flex>
              <v-flex xs12 sm12 md4 lg4 xl4
                ><p
                  class="display-3 text-xs-center text-sm-center text-md-center"
                >
                  What You Get
                </p></v-flex
              >
              <v-flex xs12 sm12 md4 lg4 xl4><hr class="hr" /></v-flex>
            </v-layout>

            <br />
            <br />
            <p class="text-size">
              There are 9 different controls in place to maintain data
              integrity. We authenticate and verify our Dashers to make sure
              your dataset is unique. You get to control the flow of data into
              your dataset.
            </p>
          </div>
          <v-img
            :src="require('@/assets/9 Control Icons.svg')"
            height="500px"
            width="auto"
          ></v-img>
        </v-flex>
      </v-layout>
      <v-layout row class="mt-3">
        <v-flex xs12 sm12 md12 class="pa-2">
          <div class="text-md-center">
            <v-layout row>
              <v-flex xs12 class="mb-2 mt-2">
                <v-card>
                  <v-layout row>
                    <v-flex xs12 sm12 md12>
                      <!-- <div class="text-md-center">
                <b class="display-1 red--text">DataDash Solution</b>
              </div> -->
                      <br />
                      <div class="text-center">
                        <v-layout row>
                          <v-flex xs12 sm12 md4 lg4 xl4
                            ><hr class="hr"
                          /></v-flex>
                          <v-flex xs12 sm12 md4 lg4 xl4
                            ><p
                              class="display-1 text-xs-center text-sm-center text-md-center"
                            >
                              Request a Demo
                            </p></v-flex
                          >
                          <v-flex xs12 sm12 md4 lg4 xl4
                            ><hr class="hr"
                          /></v-flex>
                        </v-layout>

                        <br />
                        <br />
                        <p
                          class="text-size text-xs-center text-sm-center text-md-center subheading"
                        >
                          Experience the benefits of a data-driven approach with
                          our data collection platform. Stay ahead of the
                          competition, unlock new business opportunities, and
                          make informed decisions that drive your organization’s
                          growth. Discover the power of our platform today and
                          revolutionize the way you collect, analyze, and
                          leverage data. Request for a demo!
                        </p>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12 class="mt-2">
                      <DemoRequest />
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-layout>
</template>
<script>
import DemoRequest from "../components/DemoRequest.vue";
export default {
  data() {
    return {
      upHere: false,
      upHere1: false,
      upHere2: false,
      upHere3: false,
    };
  },
  components: {
    DemoRequest,
  },
};
</script>
<style scoped>
.text-size {
  font-size: 16px;
}
.text-size2 {
  font-size: 15px;
}
.scrollable {
  height: 700px; /* or any height you want */
  overflow-y: auto;
}
.hr {
  margin-top: 35px;
}
.rounded-card {
  border-radius: 20px;
}
.background {
  background-color: #f44336;
}
.hovering:hover {
  display: none;
}
.showing:hover {
  display: block;
}
.inner-img{
  border-radius: 50%; border: 2px solid black; height: auto;background-color: white;
}
.outer-img{
  border-radius: 50%; border: 2px solid gray;margin-top: 50%;
}
</style>
